import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { CommonAppModule } from '../common/common-app.module';
import { OperationWizardModule } from '../common/operation-wizard/operation-wizard.module';
import { AppDownloadModule } from '../shared/app-download/app-download.module';
import { SipPhoneCallModule } from '../shared/sip-phone-call/sip-phone-call.module';
import { SvgCommonModule } from '../shared/svg/svg-common.module';
import { TechnicalAlertsModule } from '../shared/technical-alerts/technical-alerts.module';
import { UiModule } from '../ui/ui.module';

import { SectionsService } from './../sections/sections.service';
import { AuthorizationGuardService } from './authorization-guard.service';
import { BiometricsRegistrationModule } from './biometrics-registration/biometrics-registration.module';
import { AuthorizationLayoutModule } from './layout/layout.module';

@NgModule({
	imports: [
		CommonModule,
		CommonAppModule,

		UiModule,
		OperationWizardModule,

		FormsModule,
		TechnicalAlertsModule,
		SvgCommonModule,
		SipPhoneCallModule,
		AppDownloadModule,
		BiometricsRegistrationModule,
		AuthorizationLayoutModule,

	],
	declarations: [
		// AuthorizationEnabledComponent,
		// ResetPasswordComponent,
		// LoginComponent,
		// LoginHeaderComponent,
		// LoginFooterComponent,
		// LoginMainInformationComponent,
		// LoginAdSliderComponent,
		//  ChangeTemporaryPasswordComponent,
		// LogoutTimeoutComponent,
		// LossSessionComponent,

	],
	exports: [
		//  ResetPasswordComponent,
	],
	providers: [
		AuthorizationGuardService,
		SectionsService,
	],
})
export class AuthorizationModule { }
